import {resetRouter} from '@/router/index'

export default {
    name: 'Login',
    watch: {
        '$i18n.locale' (val) {
            this.loginFormChange(val);
        }
    },
    created() {
        // this.$i18n.locale = 'en';
        this.loginFormChange(this.$i18n.locale);
        if (sessionStorage.getItem('currentSystem')) {
            this.$router.push('/home');
        }
    },
    data() {
        var checkUserName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.$t('login.userNameIsNotNull')));
            }
            callback();
        };
        var validatePass = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.$t('login.passwordIsNotNull')));
            }
            callback();
        };
        // 验证码校验规则
        var validateVerificationCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.$t('login.verificationCodeIsNotNull')));
            }
            callback();
        };
        const checkPhone = (rule, value, callback) => {
            let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            if (value === "") {
                callback(new Error(this.$t('ch_register.message.phone')));
            //引入methods中封装的检查手机格式的方法
            } else if (!phoneReg.test(value)) {
                callback(new Error(this.$t('ch_register.message.errPhone')));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                password: '',
                userName: '',
            },
            rules: {
                password: [
                    {validator: validatePass, trigger: 'blur'}
                ],
                userName: [
                    {validator: checkUserName, trigger: 'blur'}
                ]
            },
            // 中英文登录标识  0：中文 1：英文
            loginlanguageFlag : 1,
            chLoginForm: {
                phone: '',
                verificationCode: '',
            },
            chLoginRules: {
                phone: [
                    {required: true, validator: checkPhone, trigger: 'blur'},
                   /*  { pattern: /^1[3-9]\d{9}$/, message: this.$t('ch_register.message.errPhone') } */
                ],
                verificationCode: [
                    {validator: validateVerificationCode, trigger: 'blur'}
                ]
            },
            verificationCodeButtonName:'获取验证码',
            verificationCodeButtonDis : true,
        };
        
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let loginUrl = '';
                    if (this.loginlanguageFlag === 0) {
                        loginUrl = `/api/oauth/token?grant_type=sms&client_id=jbyclient&client_secret=jbysecret&phone=${this.chLoginForm.phone}&smsCode=${this.chLoginForm.verificationCode}`;
                    }
                    if (this.loginlanguageFlag === 1) {
                        loginUrl = `/api/oauth/token?grant_type=password&client_id=jbyclient&client_secret=jbysecret&username=${this.ruleForm.userName}&password=${this.ruleForm.password}`;
                    }
                    sessionStorage.setItem('loginFlag', this.loginlanguageFlag);
                    this.$axios.get(loginUrl)
                        .then((response) => {
                            const token = response.data.access_token;
                            sessionStorage.setItem('token', token);
                            // 登录以后获取token中的菜单信息数据源
                            // 根据用户获取菜单
                            this.$axios.get('/api/accounts/allMenu').then(resAll => {
                                sessionStorage.setItem('allMenu', JSON.stringify(resAll.data.resultData));
                                this.$axios.get(`/api/accounts/menu`).then((res) => {
                                    const systems = res.data.resultData;
                                    if (systems && systems.length > 0) {
                                        const current = systems[0];
                                        // 处理多系统菜单及名称
                                        const currentSystem = {
                                            zhName: current.systemName,
                                            enName: current.systemEnName,
                                            routeData: current.menulist,
                                            code: current.systemCode
                                        };
                                        sessionStorage.setItem('currentSystem', JSON.stringify(currentSystem));
                                    }
                                    if (systems && systems.length > 1) {
                                        const other = systems[1];
                                        // 处理多系统菜单及名称
                                        const otherSystem = {
                                            zhName: other.systemName,
                                            enName: other.systemEnName,
                                            routeData: other.menulist,
                                            code: other.systemCode
                                        };
                                        sessionStorage.setItem('otherSystem', JSON.stringify(otherSystem));
                                    }
                                    // 根据用户登录的菜单动态处理路由
                                    resetRouter(sessionStorage.getItem('allMenu'), sessionStorage.getItem('currentSystem'));
                                    this.$router.push('/home');
                                }).catch((e) => {
                                    console.log(e)
                                });
                            }).catch(e => {
                                console.log(e);
                                this.$message({
                                    message: this.$t('EM-101'),
                                    type: 'error',
                                    center: true
                                });
                            });
                    }).catch((exception) => {
                        console.log(exception);
                        // 验证码登录
                        if (this.loginlanguageFlag === 0) {
                            this.$message({
                                message: '手机号或验证码错误',
                                type: 'error',
                                center: true
                            });
                        }
                        // 密码登录
                        if (this.loginlanguageFlag === 1) {
                            this.$message({
                                message: 'username or password error',
                                type: 'error',
                                center: true
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        register() {
            // this.$refs[formName].resetFields();
            this.$router.push('register');
        },
        getVerificationCode() {
            this.verificationCodeButtonDis = true;
            console.log(this.chLoginForm.phone);
            const param = {};
            param.phone = this.chLoginForm.phone;
            this.$axios.get('/api/sendSms/ssosend', {params: param}).then(response => {
                if (response.data.status === '1') {
                    this.$message({
                        message: this.$t('login.message.verificationCodeSendSuccess'),
                        type: 'success',
                        center: true
                    });
                    this.changeVerificationCodeButtonName();
                } else {
                    this.$message({
                        message: this.$t('login.message.verificationCodeSendFailure'),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('login.message.verificationCodeSendFailure'),
                    type: 'error',
                    center: true
                });
            });
            
        },
        //验证码倒数60秒
        changeVerificationCodeButtonName(){       
            let time = 120;
            let timer = setInterval(() => {
                if(time === 0){
                    clearInterval(timer);
                    this.verificationCodeButtonName = this.$t('ch_register.getVerificationCode');
                    this.verificationCodeButtonDis = false;
                    // 手机号允许修改   
                    this.phoneDis = false;
                }else{
                    this.verificationCodeButtonDis = true;
                    // 手机号禁止修改
                    this.phoneDis = true;
                    this.verificationCodeButtonName = time + this.$t('ch_register.secondRetry');
                    time--;
                }
            }, 1000);
        },
        // 手机号变化
        phoneChange(formName) {
            this.$refs[formName].validateField('phone', (phoneIsValid) => {
                if (!phoneIsValid) {
                    this.verificationCodeButtonDis = false;
                } else {
                    this.verificationCodeButtonDis = true;
                }
			})
        },
        loginFormChange(locale) {
            if(locale.indexOf('en') !== -1){
                this.loginlanguageFlag = 1;
            }else{
                this.loginlanguageFlag = 0;
            }
        },
        changeLoginType(value){
            if(value === 1){
                this.loginlanguageFlag = 1;
                this.$i18n.locale = 'en';
            }else {
                this.loginlanguageFlag = 0;
                this.$i18n.locale = 'zh';
            }
        }
    },
    
};
